/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogTitle, DialogContent, IconButton } from '@material-ui/core';
import { Icon } from '@iconify/react';

import { useTheme } from '@material-ui/core/styles';

ExclusionRuleDialog.propType = {
  btnName: PropTypes.string,
  ComponentCalled: PropTypes.func,
  dialogTitle: PropTypes.string,
  showbtnIcon: PropTypes.bool,
  filterOptions: PropTypes.array,
  icon: PropTypes.object,
  editId: PropTypes.object,
  parentRuleId: PropTypes.number,
  title: PropTypes.string
};

export default function ExclusionRuleDialog({
  dialogTitle,
  btnName = 'Add',
  ComponentCalled,
  showbtnIcon = false,
  filterOptions,
  customName,
  icon,
  editId,
  parentRuleId,
  title = ''
}) {
  const [open, setOpen] = useState(false);
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('sm');
  const handleClickOpen = () => {
    setOpen(true);
  };
  const theme = useTheme();

  const handleClose = () => {
    setOpen(false);
  };

  const stylesSheelt = {
    background: '#eeeeee',
    color: theme.palette.primary.main,
    boxShadow: 'none',
    fontSize: '0.78rem',
    fontWeight: '600',
    minWidth: '55px',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#eeeeee'
    }
  };

  return (
    <>
      {icon ? (
        <IconButton size="small" onClick={() => handleClickOpen()} title={title}>
          <Icon icon={icon} />
        </IconButton>
      ) : (
        <Button onClick={() => handleClickOpen()} size="small" variant="contained" sx={stylesSheelt}>
          Edit
        </Button>
      )}
      <Dialog open={open} maxWidth={maxWidth} onClose={handleClose} fullWidth={fullWidth}>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent style={{ padding: '24px' }}>
          {filterOptions ? (
            <ComponentCalled handleClose={handleClose} filterOptions={filterOptions} />
          ) : (
            <ComponentCalled
              handleClose={handleClose}
              customName={customName}
              editId={editId}
              parentRuleId={parentRuleId}
            />
          )}
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={handleClose} variant="contained">
            Close
          </Button>
        </DialogActions> */}
      </Dialog>
    </>
  );
}
